<template>
	<b-container fluid>
		<page-title><h2 v-if="item"><router-link :to="{ name: 'CurrencyTypeList' }" class="nav-link">Waluty</router-link>/Edycja</h2></page-title>

		<div class="col page-element">
			<div v-if="created" class="alert alert-success" role="status">{{ created['@id'] }} created.</div>
			<div v-if="updated" class="alert alert-success" role="status">{{ updated['@id'] }} updated.</div>
			<alert-loading v-if="retrieveLoading || updateLoading"></alert-loading>
			<div v-if="retrieveError" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ retrieveError }}</div>
			<div v-if="updateError" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ updateError }}</div>

			<CurrencyTypeForm v-if="item && !retrieveLoading && !updateLoading" :handle-submit="update" :values="item" :errors="violations" :initialValues="retrieved"></CurrencyTypeForm>
		</div>
	</b-container>
</template>

<script>
  import CurrencyTypeForm from './Form.vue';
  import { mapGetters } from 'vuex';

  export default {
    created () {
      this.$store.dispatch('currencytype/update/retrieve', decodeURIComponent(this.$route.params.id));
    },
    components: {
      CurrencyTypeForm
    },
    computed: {
      ...mapGetters({
        retrieveError: 'currencytype/update/retrieveError',
        retrieveLoading: 'currencytype/update/retrieveLoading',
        updateError: 'currencytype/update/updateError',
        updateLoading: 'currencytype/update/updateLoading',
        deleteLoading: 'currencytype/del/loading',
        created: 'currencytype/create/created',
        retrieved: 'currencytype/update/retrieved',
        updated: 'currencytype/update/updated',
        violations: 'currencytype/update/violations'
      })
    },
    data: function() {
      return {
        item: {}
      }
    },
    methods: {
      update (values) {
        this.$store.dispatch('currencytype/update/update', {item: this.retrieved, values: values });
      },
      reset () {
        this.$store.dispatch('currencytype/update/reset');
        this.$store.dispatch('currencytype/del/reset');
        this.$store.dispatch('currencytype/create/reset');

      }
    },
    beforeDestroy() {
      this.reset();
    }
  }
</script>



// WEBPACK FOOTER //
// Update.vue?37e74a53